import React from 'react';
import { SparkleIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
import { ProductName } from './ProductName';
const frictionPoints = ['Plus besoin de passer des heures à chercher de nouveaux exercices.', 'Plus besoin de reconstruire chaque progression.', 'Plus besoin d’improviser vos corrections.', 'Plus besoin de vous demander constamment quoi enseigner ensuite.', 'Plus besoin de créer une séance entière lorsque vous manquez de temps.', 'Plus besoin de deviner si vos élèves sont prêtes à passer à l’étape suivante.'];
const included = [{
  label: 'VOLUME 01',
  title: 'Fondamentaux de la Danse Classique & Placement'
}, {
  label: 'VOLUME 02',
  title: 'La Barre : Technique, Exercices, Progressions & Corrections'
}, {
  label: 'VOLUME 03',
  title: 'Le Centre : Adage, Équilibre, Coordination & Placement'
}, {
  label: 'VOLUME 04',
  title: 'Pirouettes, Tours, Sauts & Allegro'
}, {
  label: 'VOLUME 05',
  title: 'Progressions, Niveaux, Corrections & Évaluation'
}, {
  label: 'VOLUME 06',
  title: '150 Cours Prêts à Enseigner'
}, {
  label: 'BONUS 01',
  title: 'Guide des Corrections Techniques en Danse Classique'
}, {
  label: 'BONUS 02',
  title: 'Progressions Techniques par Niveau en Danse Classique'
}, {
  label: 'BONUS 03',
  title: 'Bibliothèque de Consignes Pédagogiques pour Professeurs de Ballet'
}, {
  label: 'BONUS 04',
  title: 'Système d’Évaluation & Suivi des Élèves en Danse Classique'
}, {
  label: 'BONUS 05',
  title: '30 Plans de Cours d’Urgence pour Danse Classique'
}];
export function FinalCTA() {
  return <section className="bg-brand-cream px-4 py-20 sm:py-28" data-id="element-81" data-mp="30095oruor179">
      <div className="mx-auto max-w-4xl" data-id="element-82" data-mp="34un6j9s4a0jb">
        <div className="text-center" data-id="element-83" data-mp="39sf5uov3coxj">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-deep" data-id="element-84" data-mp="39rdhjip2e5xv">
            Votre prochaine semaine de cours
          </p>
          <h2 className="mt-3 text-3xl font-semibold leading-tight text-brand-ink sm:text-4xl" data-id="element-85" data-mp="3epotq02u0sj9">
            Vous pouvez continuer à préparer vos séances à partir de zéro…
            <br data-id="element-86" data-mp="1jov0hsb1kacw" />
            <span className="italic text-brand-deep" data-id="element-87" data-mp="1jm8ys9au0p2l">
              Ou commencer à travailler avec un système déjà organisé.
            </span>
          </h2>
          <div className="mx-auto mt-10 max-w-2xl rounded-xl border border-brand-line bg-white p-7 text-left shadow-card" data-id="element-88" data-mp="1shovqz6vvkce">
            <ul className="space-y-3" data-id="element-89" data-mp="1nonfamr13cqp">
              {frictionPoints.map(point => <li key={point} className="flex gap-3 text-sm leading-6 text-brand-muted" data-id="element-90" data-mp="22d9t2k10bwft">
                  <SparkleIcon size={16} className="mt-1 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-91" data-mp="2bfj0h10zb9oz" />
                  {point}
                </li>)}
            </ul>
          </div>
          <p className="mt-10 font-display text-3xl font-semibold text-brand-deep" data-id="element-92" data-mp="h3ktl5q56pw9">
            Moins de préparation. Plus de structure. Plus de temps pour
            enseigner.
          </p>
        </div>

        <div className="mt-14 rounded-2xl border border-brand-gold/60 bg-white p-7 shadow-soft sm:p-11" data-id="element-93" data-mp="2yc43hzvp1vn">
          <h3 className="text-center text-3xl font-semibold text-brand-ink" data-id="element-94" data-mp="6ze5a4dcvo09">
            Tout ce qui est inclus
          </h3>
          <ul className="mt-8 grid gap-x-8 md:grid-cols-2" data-id="element-95" data-mp="3ua409e63aj2u">
            {included.map(item => <li key={item.label} className="flex items-baseline gap-3 border-b border-brand-line py-3" data-id="element-96" data-mp="3fcv6yex8758h">
                <span className={`w-[84px] shrink-0 text-[11px] font-bold tracking-[0.12em] ${item.label.startsWith('BONUS') ? 'text-brand-deep' : 'text-brand-gold'}`} data-id="element-97" data-mp="3kad5rchj442r">
                  {item.label}
                </span>
                <span className="text-sm font-medium leading-6 text-brand-ink" data-id="element-98" data-mp="14md6mseztk4h">
                  {item.title}
                </span>
              </li>)}
          </ul>
          <p className="mt-6 text-center text-xs font-medium text-brand-muted" data-id="element-99" data-mp="35o2yo8l9om3h">
            Format PDF · Accès immédiat · Contenu principal entièrement visuel
          </p>

          <div className="mt-10 border-y border-brand-line bg-brand-blush px-6 py-9 text-center" data-id="element-100" data-mp="30mne0hn04hlm">
            <p className="font-display text-2xl font-semibold text-brand-ink" data-id="element-101" data-mp="2vr81pu4n6trb">
              <ProductName data-id="element-102" data-mp="2rnib6z4eq23n" />
            </p>
            <p className="mx-auto mt-3 max-w-xl font-display text-xl italic leading-8 text-brand-ink" data-id="element-103" data-mp="2mp74uydbm9q6">
              Préparez une année entière de cours de danse classique en
              seulement 5 minutes.
            </p>
            <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-brand-muted" data-id="element-104" data-mp="2cznktpdvg9tq">
              150 cours prêts à enseigner, progressions techniques, exercices,
              corrections, évaluations et outils pédagogiques pour professeurs
              de danse classique.
            </p>
            <p className="mt-5 text-xs font-bold tracking-[0.16em] text-brand-gold" data-id="element-105" data-mp="1z05sj01daefm">
              6 VOLUMES · 5 BONUS · UN SEUL SYSTÈME
            </p>
          </div>

          <div className="mt-9 text-center" data-id="element-106" data-mp="jfwsfsdasnpe">
            <p className="font-display text-5xl font-semibold text-brand-ink" data-id="element-107" data-mp="jeln3o47f7w6">
              27 EUR
            </p>
            <CheckoutButton className="mt-7" data-id="element-108" data-mp="nijqib0kb4v1">
              ACCÉDEZ À PROFESSEUR DE DANSE CLASSIQUE PRO MAINTENANT
            </CheckoutButton>
            <p className="mt-5 text-xs text-brand-muted" data-id="element-109" data-mp="3rwi45gxbduw7">
              Paiement sécurisé · Accès immédiat · Format PDF
            </p>
          </div>
        </div>
      </div>
    </section>;
}